<div>
  <!-- DISPLAY -->
  <div class="px-5 pb-5 border-b">
    <h2 class="py-4 font-semibold text-sm">
      {{ "landing-page-builder.display" | translate }}
    </h2>

    <div class="flex flex-col gap-3">
      <!-- Line -->
      <div class="flex items-center justify-between">
        <span class="text-gray-500 text-sm h-9 leading-9 pr-3">{{
          "landing-page-builder.line" | translate
        }}</span>
        <p-inputNumber
          class="h-9"
          [min]="1"
          [max]="5"
          [(ngModel)]="blockData.line"
          (onInput)="onLineChange($event)"
        />
      </div>
      <p class="text-xs text-orange-dark-600">
        {{ "landing-page-builder.max-number-of-line" | translate }}
      </p>
      <!-- Items per line -->
      <div class="flex items-center justify-between">
        <span class="text-gray-500 text-sm h-9 leading-9 pr-3">
          {{ "landing-page-builder.items-per-line" | translate }}
        </span>
        <p-inputNumber
          class="h-9"
          [min]="4"
          [max]="6"
          [(ngModel)]="blockData.itemPerLine"
          [disabled]="true"
        />
      </div>
    </div>
  </div>

  <div class="px-5 pb-5 border-b">
    <h2 class="py-4 font-semibold text-sm">
      {{ "landing-page-builder.vouchers" | translate }}
      {{ (blockData.vouchers || []).length }}/{{ maxVoucher }}
    </h2>

    <div
      class="button"
      [ngClass]="{
        'bg-gray-50 text-gray-300 hover:!bg-gray-50 !cursor-default':
          maxVoucher === (blockData.vouchers || []).length
      }"
      (click)="onToggleAddVoucher()"
    >
      {{ "landing-page-builder.select-voucher" | translate }}
    </div>

    <div class="pt-4 flex flex-col gap-3">
      <div
        class="flex items-center gap-2"
        *ngFor="let voucher of blockData.vouchers; let i = index"
      >
        <div class="flex flex-col">
          <i
            class="{{ SoctripIcons.CHEVRON_UP }}"
            [ngClass]="i === 0 ? 'opacity-50' : 'cursor-pointer'"
            (click)="i !== 0 ? onMoveUpSort(i) : null"
          ></i>
          <i
            class="{{ SoctripIcons.CHEVRON_DOWN }}"
            [ngClass]="
              i === blockData.sorts.length - 1 ? 'opacity-50' : 'cursor-pointer'
            "
            (click)="
              i !== blockData.sorts.length - 1 ? onMoveDownSort(i) : null
            "
          ></i>
        </div>
        <div class="flex-1 flex items-center gap-2">
          <div class="w-10 h-10">
            <ng-container *ngIf="!voucher?.avatar_id; else customImage">
              <div>
                <img src="/assets/icons/voucher.svg" alt="Voucher Icon" />
              </div>
            </ng-container>
            <ng-template #customImage>
              <app-custom-image
                styleClass="w-full h-full rounded overflow-hidden"
                [imgId]="voucher?.avatar_id"
                [alt]="voucher?.name"
              ></app-custom-image>
            </ng-template>
          </div>

          <div class="flex flex-col justify-between">
            <span class="font-medium text-sm">{{ voucher.name }}</span>
            <span class="text-xs text-gray-500"
              >{{ "landing-page-builder.valid-through" | translate }}
              {{ voucher.end_date | date: "HH:mm, MM/dd/yyyy" }}</span
            >
          </div>
        </div>
        <i
          class="{{ SoctripIcons.X_CLOSE }} cursor-pointer"
          (click)="onDeleteVoucher(voucher.id)"
        ></i>
      </div>
    </div>

    <app-add-voucher-modal
      [max]="blockData.line * blockData.itemPerLine"
      [(isModal)]="isModalVoucher"
      [(selectedVouchers)]="blockData.vouchers"
    ></app-add-voucher-modal>
  </div>
</div>
